import React from 'react';
import type { Testimonial } from '../data/testimonials';
type TestimonialsProps = {
  testimonials: Testimonial[];
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  background?: 'white' | 'glacier';
};
const laneColors = ['bg-mint', 'bg-amber', 'bg-coral'];

/**
 * Pre-launch: these cards hold real, public quotes from coaches (voice of
 * customer), each with its source — not reviews of the product, and shown
 * without star ratings. Swap in verified buyer reviews after launch.
 */
export function Testimonials({
  testimonials,
  eyebrow = 'Coach to coach',
  title = 'What coaches are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-glacier-soft';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-424" data-mp="2s3jfu4z9ykk6">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-425" data-mp="v8dite99jy8p">
        <div className="text-center" data-id="element-426" data-mp="qaljhz6ah9uh">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-amber-deep" data-id="element-427" data-mp="qbn7t5cbfsu5">
            {eyebrow}
          </p>
          <h2 className="mt-3 font-display font-bold text-rink text-3xl sm:text-5xl" data-id="element-428" data-mp="h818trjkkmm2">
            {title}
          </h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-429" data-mp="78k3jb88caqm">
              {subtitle}
            </p>}
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-430" data-mp="c73rtiaapym5">
          {testimonials.map((item, i) => <figure key={i} className="flex flex-col rounded-card border border-ice-dark bg-white p-5 shadow-card" data-id="element-431" data-mp="zysd4eop9mtl" data-mpi={i}>
              <span aria-hidden="true" className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-2xl font-extrabold leading-none text-rink-deep ${laneColors[i % 3]}`} data-id="element-432" data-mp="q5v18re7qw3y">
                “
              </span>
              <blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-ink" data-id="element-433" data-mp="1nma80j39h10s">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-434" data-mp="1xh7n6s4ya4ph">
                <span className="block text-[13px] font-semibold text-rink" data-id="element-435" data-mp="1sjz6yx3d4aqv">
                  {item.author}
                </span>
                {item.url ? <a href={item.url} target="_blank" rel="noopener noreferrer" className="hover:text-rink hover:underline" data-id="element-436" data-mp="1jihs1i1oyf3r">
                    {item.role}
                  </a> : item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}